import { cnyShipToAddressActionTypes } from "../actions/cnyShipToAddress.actions";

// Initialize from localStorage if available
const getInitialState = () => {
  try {
    const storedAddress = localStorage.getItem("cnyShipToAddress");
    if (storedAddress) {
      const parsedAddress = JSON.parse(storedAddress);
      return {
        address: parsedAddress,
        isSet: true,
      };
    }
  } catch (error) {
    console.warn("Error loading CNY address from localStorage:", error);
  }
  
  return {
    address: null,
    isSet: false,
  };
};

const initialState = getInitialState();

export default function cnyShipToAddressReducer(state = initialState, action) {
  switch (action.type) {
    case cnyShipToAddressActionTypes.SET_CNY_SHIPTO_ADDRESS:
      return {
        ...state,
        address: action.payload,
        isSet: action.payload !== null,
      };
    
    case cnyShipToAddressActionTypes.CLEAR_CNY_SHIPTO_ADDRESS:
      return {
        ...state,
        address: null,
        isSet: false,
      };
    
    default:
      return state;
  }
}
